<template>
  <v-card>
    <v-card-title v-if="this.$store.state.visible == false">
      <v-btn small text v-on:click="openCalendar()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      {{ $t("selectDate") }}
    </v-card-title>
    <v-divider></v-divider>
    <v-container v-bind="{ [`grid-list-sm`]: true }" fluid>
      <v-row justify="center">
        <v-col lg="6" md="6" sm="12" cols="12" style="max-width: 290px;">
          <v-date-picker class="regularText" style="min-width: 290px; display: grid; box-shadow: none;" no-title multiple :events="events"
            :event-color="colorTheme" v-model="Dates" :max="this.$store.state.maxDate" :color="colorTheme"
            :locale="this.$i18n.locale"></v-date-picker>
        </v-col>
        <v-col lg="6" md="6" sm="12" cols="12" style="max-width: 290px; text-align: center;">
          <v-row>
            <v-col cols="12">
              <v-btn class="regularText" outlined :color="colorTheme" @click="today()" style="width: 80% !important;max-width: 270px;">{{
                $t("today").toUpperCase() }}</v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn class="regularText" outlined :color="colorTheme" @click="setDate(7)" style="width: 80% !important;max-width: 270px;">
                {{ $t("last").toUpperCase() }} 7
                {{ $t("days").toUpperCase() }}
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn class="regularText" outlined :color="colorTheme" @click="setDate(14)"
                style="width: 80% !important;max-width: 270px;">
                {{ $t("last").toUpperCase() }} 14
                {{ $t("days").toUpperCase() }}
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn class="regularText" outlined :color="colorTheme" @click="setDate(30)"
                style="width: 80% !important;max-width: 270px;">
                {{ $t("last").toUpperCase() }} 30
                {{ $t("days").toUpperCase() }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="6" md="6" style="text-align: center;">
          <p class="regularText ma-0">{{ $t("from") }} {{ fromDate }}</p>
          <v-row>
            <v-col cols="12">
              <v-btn-toggle>
                <v-btn text>
                  {{ hourStart }}
                  <span style="display: grid;padding-left: 5px;">
                    <v-icon style="font-size: large;height: 10px;padding-bottom: 10px;"
                      v-on:click="addHours(0)">mdi-chevron-up</v-icon>
                    <v-icon style="font-size: large;height: 10px;padding-top: 10px;"
                      v-on:click="removeHours(0)">mdi-chevron-down</v-icon>
                  </span>
                </v-btn>
                <v-btn text>
                  {{ minStart }}
                  <span style="display: grid;padding-left: 5px;">
                    <v-icon style="font-size: large;height: 10px;padding-bottom: 10px;"
                      v-on:click="addMinutes(0)">mdi-chevron-up</v-icon>
                    <v-icon style="font-size: large;height: 10px;padding-top: 10px;"
                      v-on:click="removeMinutes(0)">mdi-chevron-down</v-icon>
                  </span>
                </v-btn>
                <v-btn text disabled>
                  <v-icon class="icon-size" :color="colorTheme">mdi-clock-outline</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6" style="text-align: center;">
          <p class="regularText ma-0">{{ $t("to") }} {{ toDate }}</p>
          <v-row>
            <v-col cols="12">
              <v-btn-toggle>
                <v-btn text>
                  {{ hourEnd }}
                  <span style="display: grid;padding-left: 5px;">
                    <v-icon style="font-size: large;height: 10px;padding-bottom: 10px;"
                      v-on:click="addHours(1)">mdi-chevron-up</v-icon>
                    <v-icon style="font-size: large;height: 10px;padding-top: 10px;"
                      v-on:click="removeHours(1)">mdi-chevron-down</v-icon>
                  </span>
                </v-btn>
                <v-btn text>
                  {{ minEnd }}
                  <span style="display: grid;padding-left: 5px;">
                    <v-icon style="font-size: large;height: 10px;padding-bottom: 10px;"
                      v-on:click="addMinutes(1)">mdi-chevron-up</v-icon>
                    <v-icon style="font-size: large;height: 10px;padding-top: 10px;"
                      v-on:click="removeMinutes(1)">mdi-chevron-down</v-icon>
                  </span>
                </v-btn>
                <v-btn text disabled>
                  <v-icon class="icon-size" :color="colorTheme">mdi-clock-outline</v-icon>
                </v-btn>
                <!--              <v-menu ref="menu" v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                  :return-value.sync="time" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-model="time" v-bind="attrs" v-on="on"><v-icon
                        :color="colorTheme">mdi-clock-outline</v-icon></v-btn>
                  </template>
                  <v-time-picker v-if="menu2" v-model="time" full-width
                    @click:minute="$refs.menu.save(time)"></v-time-picker>
                </v-menu> -->
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn class="regularText" text @click="openCalendar()">
        {{ $t("cancel").toUpperCase() }}
      </v-btn>
      <v-btn class="regularText" :color="colorTheme" text @click="
        setPeriodDates();
      openCalendar();
                        ">{{ $t("accept").toUpperCase() }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import i18n from "@/plugins/i18n";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "calendarTime",
  data: () => ({
    Dates: [],
    DatesTracking: [],
    events: [],
    days: 0,
    minStart: "",
    hourStart: "",
    minEnd: "",
    hourEnd: "",
    dateStart: moment().format("2019-12-20 00:00"),
    dateEnd: moment().format("2019-12-20 23:59"),
    time: null,
    menu2: false,
  }),
  computed: {
    ...mapState([
      "colorTheme",
      "setLocale",
      "Hours",
      "Minutes",
      "calendarTime",
      "disableButton",
    ]),
    fromDate() {
      let dateFormat = i18n.locale == "en" ? "MMM/DD/YYYY" : "DD/MMM/YYYY";

      var fromdate = this.Dates[0];
      if (this.Dates.length > 1) {
        fromdate = moment(fromdate).isBefore(this.Dates[1])
          ? fromdate
          : this.Dates[1];
      }

      let fromDateStrig = moment(fromdate, "YYYY-MM-DD").format(dateFormat);
      if (i18n.locale != "en") fromDateStrig = fromDateStrig.replace(".", "");

      return fromDateStrig;
    },
    toDate() {
      let dateFormat = i18n.locale == "en" ? "MMM/DD/YYYY" : "DD/MMM/YYYY";

      var todate = this.Dates[0];
      if (this.Dates.length > 1) {
        todate = moment(todate).isBefore(this.Dates[1])
          ? this.Dates[1]
          : todate;
      }

      let todateString = moment(todate, "YYYY-MM-DD").format(dateFormat);
      if (i18n.locale != "en") todateString = todateString.replace(".", "");

      return todateString;
    },
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.Dates = this.$store.state.datesCalendar;
    this.DatesTracking = this.$store.state.datesCalendar;
    this.events = this.$store.state.datesBetween;
    var sClock = localStorage.getItem("startClock");
    var eClock = localStorage.getItem("endClock");

    this.hourStart =
      sClock == null || sClock == undefined ? "00" : sClock.substring(0, 2);
    this.hourEnd =
      eClock == null || eClock == undefined ? "23" : eClock.substring(0, 2);
    this.minStart =
      sClock == null || sClock == undefined ? "00" : sClock.substring(3, 5);
    this.minEnd =
      eClock == null || eClock == undefined ? "59" : eClock.substring(3, 5);

    this.dateStart =
      this.$store.state.datesCalendar[0] +
      " " +
      this.hourStart +
      ":" +
      this.minStart;
    this.dateEnd =
      this.$store.state.datesCalendar[0] +
      " " +
      this.hourEnd +
      ":" +
      this.minEnd;
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    addHours(val) {
      //console.log(this.dateStart);
      //console.log(val);
      if (val == 0) {
        this.dateStart = moment(this.dateStart)
          .add(1, "hours")
          .format("YYYY-MM-DD HH:mm");
      } else {
        this.dateEnd = moment(this.dateEnd)
          .add(1, "hours")
          .format("YYYY-MM-DD HH:mm");
      }
    },
    addMinutes(val) {
      if (val == 0) {
        this.dateStart = moment(this.dateStart)
          .add(1, "minutes")
          .format("YYYY-MM-DD HH:mm");
        if (this.minStart == "59") {
          this.dateStart = moment(this.dateStart)
            .subtract(1, "hour")
            .format("YYYY-MM-DD HH:mm");
        }
      } else {
        this.dateEnd = moment(this.dateEnd)
          .add(1, "minutes")
          .format("YYYY-MM-DD HH:mm");
        if (this.minEnd == "59") {
          this.dateEnd = moment(this.dateEnd)
            .subtract(1, "hour")
            .format("YYYY-MM-DD HH:mm");
        }
      }
    },
    removeHours(val) {
      if (val == 0) {
        this.dateStart = moment(this.dateStart)
          .subtract(1, "hour")
          .format("YYYY-MM-DD HH:mm");
      } else {
        this.dateEnd = moment(this.dateEnd)
          .subtract(1, "hour")
          .format("YYYY-MM-DD HH:mm");
      }
    },
    removeMinutes(val) {
      if (val == 0) {
        this.dateStart = moment(this.dateStart)
          .subtract(1, "minutes")
          .format("YYYY-MM-DD HH:mm");
        if (this.minStart == "00") {
          this.dateStart = moment(this.dateStart)
            .add(1, "hour")
            .format("YYYY-MM-DD HH:mm");
        }
      } else {
        this.dateEnd = moment(this.dateEnd)
          .subtract(1, "minutes")
          .format("YYYY-MM-DD HH:mm");
        if (this.minEnd == "00") {
          this.dateEnd = moment(this.dateEnd)
            .add(1, "hour")
            .format("YYYY-MM-DD HH:mm");
        }
      }
    },
    setPeriodDates() {
      if (this.days <= 60) {
        if (this.hourStart == null || this.hourStart == undefined) {
          this.hourStart = "00";
          this.minStart = "00";
        }

        if (this.hourEnd == null || this.hourEnd == undefined) {
          this.hourEnd = "00";
          this.minEnd = "00";
        }
        var start = this.hourStart + ":" + this.minStart;
        var end = this.hourEnd + ":" + this.minEnd;
        var startHour = moment(start, "HH:mm");
        var endHour = moment(end, "HH:mm");
        var startDate = this.Dates[0];
        var endDate = this.Dates.length == 2 ? this.Dates[1] : this.Dates[0];

        if (startHour.isBefore(endHour) || startDate != endDate) {
          if (this.$route.path == "/individualFuel") {
            if (this.Dates.length > 1) {
              if (moment(this.Dates[0]).isBefore(this.Dates[1])) {
                startDate = this.Dates[0];
                endDate = this.Dates[1];
              } else {
                startDate = this.Dates[1];
                endDate = this.Dates[0];
              }
            }
            localStorage.setItem("startDateAF", startDate);
            localStorage.setItem("endDateAF", endDate);
            localStorage.setItem("startClockAF", start);
            localStorage.setItem("endClockAF", end);
            localStorage.setItem("PeriodTitleAF", JSON.stringify(this.Dates));
          } else if (this.$route.path == "/tracking") {
            if (this.Dates.length > 1) {
              if (moment(this.Dates[0]).isBefore(this.Dates[1])) {
                startDate = this.Dates[0];
                endDate = this.Dates[1];
              } else {
                startDate = this.Dates[1];
                endDate = this.Dates[0];
              }
            }
            localStorage.setItem("startDateTrack", startDate);
            localStorage.setItem("endDateTrack", endDate);
            localStorage.setItem("startClockTrack", start);
            localStorage.setItem("endClockTrack", end);
            this.$store.dispatch(
              "activityOfVehicle",
              this.$store.state.selectedVeh
            );
            this.$store.commit("cleanClustersAndMarkersPolyline");
            this.$store.commit("setDatesInfoTracking", {
              sdt: startDate,
              start: start,
              edt: endDate,
              end: end,
            });
          } else {
            localStorage.setItem("startClock", start);
            localStorage.setItem("endClock", end);
          }
          if (this.$route.path != "/tracking") {
            this.$store.commit("setPeriodTitleDates", this.Dates);
            //console.log(this.Dates);
            if (this.$route.path == "/dashboard") {
              localStorage.setItem("PeriodTitle", JSON.stringify(this.Dates));
              this.$store.dispatch("getItemsDashboard", [true, false]);
            } else if (this.$route.path == "/vehiclesExceptions") {
              setTimeout(() => {
                this.$store.dispatch("fillExceptionCharts");
              }, 5000);
            } else if (this.$route.path == "/accountBalancePage") {
              setTimeout(() => {
                this.$store.dispatch("chartFillAcountBalance");
              }, 5000);
            } else if (this.$route.path == "/individualFuel") {
              var vehicle = localStorage.getItem("vehicleAF");
              vehicle = JSON.parse(vehicle);

              this.$store.commit("setPeriodTitleDates", this.Dates);
              if (vehicle != undefined && vehicle != null) {
                this.$store.commit("viewSkeletonsFP", true);
                this.$store.commit("viewSkeletonsAR", true);
                this.$store.commit("viewSkeletonsRL", true);

                this.$store.dispatch("lastLevelWS", {
                  vehicleId: vehicle.MovilId,
                });

                this.$store.dispatch("fuelPerformance", {
                  vehicleId: vehicle.MovilId,
                  showMore: false,
                });

                this.$store.state.nickFromVehSelectedAF = vehicle.Nick;
                this.$store.state.movilIdFromVehSelectedAF = vehicle.MovilId;
              } else {
                this.$store.commit("snackbar", {
                  snackbar: true,
                  text: i18n.t("noVehicle"),
                });
              }
            }
          }
        } else {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("invalidDate"),
          });
        }
      } else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("errorFechas"),
        });
      }
    },
    today() {
      var StartDate = moment().format("YYYY-MM-DD");
      var EndDate = moment().format("YYYY-MM-DD");
      this.Dates = [StartDate];
    },
    setDate(range) {
      var EndDate = moment().format("YYYY-MM-DD");
      var StartDate = moment()
        .subtract(range, "days")
        .format("YYYY-MM-DD");
      this.Dates = [StartDate, EndDate];
    },
    eventsBetween: function (StartDate, EndDate) {
      var date = moment(StartDate).clone();
      date = moment(date)
        .add(1, "days")
        .format("YYYY-MM-DD");

      this.events = [];

      while (moment(date).isSameOrBefore(EndDate)) {
        this.events.push(date);
        date = moment(date)
          .add(1, "days")
          .format("YYYY-MM-DD");
      }

      this.$store.commit("setDatesBetween", this.events);
    },
    openCalendar() {
      this.$store.commit("calendarTime", false);
    },
  },
  watch: {
    Dates(val) {
      if (val.length > 2) {
        this.Dates.splice(0, 1);
      } else if (val.length == 0) {
        this.Dates = [moment().format("YYYY-MM-DD")];
      }
      if (val.length == 2) {
        if (moment(this.Dates[0]).isBefore(this.Dates[1])) {
          this.eventsBetween(this.Dates[0], this.Dates[1]);
          this.days = moment(this.Dates[1]).diff(moment(this.Dates[0]), "days");
        } else {
          this.eventsBetween(this.Dates[1], this.Dates[0]);
          this.days = moment(this.Dates[0]).diff(moment(this.Dates[1]), "days");
        }
      } else {
        this.periodDates = this.$t("today").toUpperCase();
        this.$store.commit("setDatesBetween", []);
        this.events = [];
      }
    },
    calendarTime(val) {
      this.Dates = this.$store.state.datesCalendar;
      this.events = this.$store.state.datesBetween;
      var sClock =
        this.$store.state.startClock == null
          ? "00:00"
          : this.$store.state.startClock;
      var eClock =
        this.$store.state.endClock == null
          ? "23:59"
          : this.$store.state.endClock;
      this.dateStart = this.$store.state.datesCalendar[0] + " " + sClock;
      this.dateEnd = this.$store.state.datesCalendar[0] + " " + eClock;
    },
    dateStart() {
      this.minStart = this.dateStart.substring(14);
      this.hourStart = this.dateStart.substring(11, 13);
    },
    dateEnd() {
      this.minEnd = this.dateEnd.substring(14);
      this.hourEnd = this.dateEnd.substring(11, 13);
    },
  },
};
</script>
